"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantRedemptionContract = void 0;
const contract_1 = require("../base/contract");
const redemption_schemas_1 = require("../../schemas/merchant/redemption.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
exports.MerchantRedemptionContract = (0, contract_1.createContract)({
    name: 'MerchantRedemption',
    baseUrl: '/merchants',
    version: '1',
    serviceModule: 'merchant',
    endpoints: {
        createRedemption: {
            method: 'POST',
            path: '/:merchantId/redemption/process',
            body: redemption_schemas_1.createRedemptionBodySchema,
            query: null,
            params: redemption_schemas_1.createRedemptionParamsSchema,
            headers: null,
            response: {
                success: redemption_schemas_1.createRedemptionResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:staff'],
            documentation: {
                summary: 'Process coupon redemption',
                description: 'Processes a coupon redemption with cashier validation, minimum purchase check, and optional credit application.',
                tags: ['Merchant', 'Redemption'],
                deprecated: false,
            },
            tests: [
                'should validate cashier code first',
                'should reject invalid cashier code',
                'should validate coupon code exists',
                'should check minimum purchase requirement',
                'should apply credit if requested',
                'should calculate final amount correctly',
            ],
        },
        listRedemptions: {
            method: 'GET',
            path: '/:merchantId/redemption/history',
            body: null,
            query: redemption_schemas_1.listRedemptionsQuerySchema,
            params: redemption_schemas_1.listRedemptionsParamsSchema,
            headers: null,
            response: {
                success: redemption_schemas_1.listRedemptionsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:staff'],
            documentation: {
                summary: 'Get redemption history',
                description: 'Retrieves paginated redemption history with optional date and user filters.',
                tags: ['Merchant', 'Redemption', 'History'],
                deprecated: false,
            },
            tests: [
                'should return paginated redemptions',
                'should filter by date range',
                'should filter by user',
                'should show refunded status',
            ],
        },
        checkCashierCode: {
            method: 'POST',
            path: '/:merchantId/redemption/validate-cashier',
            body: redemption_schemas_1.checkCashierCodeBodySchema,
            query: null,
            params: redemption_schemas_1.checkCashierCodeParamsSchema,
            headers: null,
            response: {
                success: redemption_schemas_1.checkCashierCodeResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:staff'],
            documentation: {
                summary: 'Validate cashier code',
                description: 'Validates a 4-digit cashier code before processing redemption. Returns cashier details on success.',
                tags: ['Merchant', 'Redemption', 'Cashier'],
                deprecated: false,
            },
            tests: [
                'should validate active cashier code',
                'should reject invalid code',
                'should reject disabled code',
                'should return cashier name on success',
            ],
        },
        checkCouponCode: {
            method: 'POST',
            path: '/:merchantId/redemption/validate-coupon',
            body: redemption_schemas_1.checkCouponCodeBodySchema,
            query: null,
            params: redemption_schemas_1.checkCouponCodeParamsSchema,
            headers: null,
            response: {
                success: redemption_schemas_1.checkCouponCodeResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:staff'],
            documentation: {
                summary: 'Validate coupon code for redemption',
                description: 'Validates a coupon code (QR or manual entry) before redemption. Returns coupon details on success or specific error code on failure.',
                tags: ['Merchant', 'Redemption', 'Coupon'],
                deprecated: false,
            },
            tests: [
                'should validate coupon by manual code',
                'should validate coupon by QR code',
                'should return NOT_FOUND for unknown code',
                'should return WRONG_MERCHANT for different merchant coupon',
                'should return ALREADY_REDEEMED for used coupon',
                'should return EXPIRED for expired coupon',
                'should return INVALID_FORMAT for malformed code',
            ],
        },
        // ============================================
        // V2 ENDPOINTS (uncomment when ready)
        // ============================================
        /*
        createRefund: {
            method: 'POST',
            path: '/:merchantId/redemption/:redemptionId/refund',
            body: createRefundBodySchema,
            query: null,
            params: createRefundParamsSchema,
            headers: null,
            response: {
                success: createRefundResponseSchema,
                errors: {
                    unauthorized: baseErrorResponseSchema,
                    forbidden: baseErrorResponseSchema,
                    notFound: baseErrorResponseSchema,
                    validationError: baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required', 'merchant:admin'],
            documentation: {
                summary: 'Process refund',
                description: 'Refunds a redemption. V1: commission stays (immediate grant). V2: within 3 hours cancels pending commission. Can restore coupon to wallet.',
                tags: ['Merchant', 'Redemption', 'Refund'],
                deprecated: false,
            },
            tests: [
                'should refund redemption',
                'should require reason',
                'should cancel commission if within 3 hours (V2 feature)',
                'should restore coupon if requested',
                'should not exceed original amount',
            ],
        },
        */
    },
});
